import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { cookieStorage } from '@/utils/cookies'

interface TokenState {
  token: string | null
  setToken: (token: string | null) => void
  clearToken: () => void
}

export const useTokenStore = create<TokenState>()(
  persist(
    (set) => ({
      token: null,
      setToken: (token) => set({ token }),
      clearToken: () => set({ token: null }),
    }),
    {
      name: 'session-token-storage',
      storage: createJSONStorage(() => cookieStorage),
    }
  )
)